import { tv, type VariantProps } from "tailwind-variants";

export const logoVariant = tv({
  slots: {
    base: "flex",
    icon: "",
    name: "",
  },
  variants: {
    variant: {
      "acqua-dark": {
        icon: "fill-primary-4",
        name: "fill-black dark:fill-white",
      },
      "acqua-white": {
        icon: "fill-primary-4",
        name: "fill-white dark:fill-dark",
      },
      white: {
        icon: "fill-primary-4",
        name: "fill-black dark:fill-white",
      },
      black: {
        icon: "fill-primary-4",
        name: "fill-black dark:fill-white",
      },
    },
  },
  defaultVariants: {
    variant: "acqua-dark",
  },
});

export type LogoVariantProps = VariantProps<typeof logoVariant>;

export type LogoReturnVariantProps = ReturnType<typeof logoVariant>;
